// Ghi token vào đúng chỗ: nhớ thì LocalStorage, không nhớ thì SessionStorage
export const saveToken = (token, rememberMe) => {
    if (rememberMe) {
      localStorage.setItem('token', token);
    } else {
      sessionStorage.setItem('token', token);
    }
  };
  
  export const getToken = () => {
    return localStorage.getItem('token') || sessionStorage.getItem('token');
  };
  
  export const removeToken = () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
  };
  export function isLoggedIn() {
    return !!getToken();
  }